import { ActionParameterDefinitionDTO } from '../../api/plyca-dtos-v2';
import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, ViewChild, ComponentFactoryResolver } from '@angular/core';
import {
  TaskDTO
} from '../../api/plyca-dtos';
import { ServiceLocator } from '../../ServiceLocator';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { finalize } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ActionResultDTO } from '../../api/plyca-dtos-v2';
import { ProcedureDTO } from '../../api/plyca-dtos';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { ActionService } from '../../actions/action.service';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { TaskService } from '../../tasks/task.service';




@Component({
  selector: 'set-variables',
  templateUrl: 'setVariables.template.html',
  providers: [DialogService, UIService]
})
export class SET_VARIABLES extends BaseComponent implements AfterContentInit, OnInit, OnDestroy {

  public action: string;
  public paramsDef: ActionParameterDefinitionDTO[];
  public actionService: ActionService;
  private confirmationService: ConfirmationService;

  public windowHash: string;
  public loaded = false;
  result: any;
  dto: any;

  private uiService: UIService;
  running: boolean;
  private translate: TranslateService;




  public model: any;
  tab = '';


  @ViewChild('formPlycaRef') formPlyca: formPlycaComponent;
  formConfig: FormConfig;


  constructor(

    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    protected componentFactoryResolver: ComponentFactoryResolver,
    public waitService: WaitLoadingService,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,

    private configuration: Configuration,
    public taskService: TaskService
  ) {
    super();

    this.uiService = ServiceLocator.injector.get(UIService);
    this.configuration = ServiceLocator.injector.get(Configuration);


    this.translate = ServiceLocator.injector.get(TranslateService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);

    let actionId = dialogConfig['action'].identifier ? dialogConfig['action'].identifier : dialogConfig['action'];
    this.action = actionId;
    this.model = dialogConfig['dto'];

    this.dtoTomodel();

  }
  dtoTomodel() {

    this.waitService.startWaiting();

    if (this.model.procedure) {
      // Se consulta la tarea
      this.subscribe(
        this.taskService.getTaskWithoutWork(this.model.identifier), ((task: any) => {
          this.model = task;
          this.createForm();
        }))
    } else {
      let p: ProcedureDTO;
      // O el tramite
      let idParts = this.model.identifier.split('<>');
      let url = this.configuration.PROCEDURES_SERVICE_URL.replace('{dossierId}', idParts[1]) + '/';
      this.subscribe(
        this.plycaService.get<ProcedureDTO>(url, idParts[0], {
          'expand': 'taskData,division.project,division.project.expansionSet:MINIMAL'
        }), ((procedure: any) => {
          this.model = procedure;
          this.createForm();
        }))
    }
  }

  createForm() {
    this.subscribe(this.createFormConfig(),
      (form: FormConfig) => {
        this.subscribe(this.configureFormConfig(form),
          (form: FormConfig) => {
            this.formConfig = form;
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
      })
  }

  ngOnDestroy() {
    this.uiService = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  ngOnInit() {

    this.windowHash = generateRandomIdentifier();
    this.initHeaderActions();
  }

  ngAfterContentInit() {

  }


  initHeaderInfo() {

  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService.addWindowAction(
      this.translate.instant('General.cancel'), 'fas fa-times', 'btn-secondary', true, this.windowHash),
      success => {
        this.close();
      });
    this.subscribe(this.headerActionsService.addWindowAction(
      this.translate.instant('Actions.setVariables.execute'), 'fas fa-play', 'btn-primary', true, this.windowHash),
      success => {
        this.setVariables(this.tab);
      });

  }

  close() {
    this.ref.close();
  }


  public setVariables(tab: string): Observable<any> | void {

    this.confirmationService.confirm({
      message: this.translate.instant('DossierLinks.situation.execute.confirm'),
      accept: () => {
        this.waitService.startWaiting();


        let parameters = this.parameters2string();
        console.log(
          'Ejecutando acción',
          this.action,
          'con los siguiente parametros',
          parameters
        );

        if (parameters === '') {
          this.uiService.showMessage(this.translate.instant('No.variables'),
            this.translate.instant('General.info'),
            'errorStyle'
          );
        } else {

          this.subscribe(

            this.plycaService
              .runActionByName(
                this.action, parameters
              )
              .pipe(finalize(() => {
                this.running = false;
                this.waitService.cancelWaiting();

              })),
            (result: ActionResultDTO) => {
              console.log('Acción ejecutada: ', result);
              if (result.identifier === 'OK') {
                if (result.objectResult) {
                  let msgObj = result.objectResult ? '\n' + JSON.stringify(result.objectResult) : '';
                  this.uiService.showMessage(msgObj, 'Info', 'errorStyle');
                } else {
                  this.uiService.showSuccess(this.translate.instant('Actions.exec.ok')
                    ,
                    this.translate.instant('General.info'),
                    'success'
                  );
                  // this.uiService.showMessage('La acción se ha ejecutado correctamente', 'Ok', 'successStyle');
                  this.close();
                }
              } else {
                let message = this.translate.instant('General.errorMessage');
                if (result.description) {
                  message = result.description;
                }
                this.uiService.showMessage(message, 'Error', 'errorStyle');

              }

            },
            err => {
              this.plycaErrorHandler.showServerError(err);

            }
          );
        }
      }
    });

  }



  private parameters2string(): string {

    let withVariables = false;

    let url = `${encodeURIComponent('TARGET')}=${encodeURIComponent(this.model.identifier)}`;

    let task: TaskDTO = this.model;
    if (task.taskData) {
      for (let data of task.taskData) {
        if (!data.readOnly) {
          url += '&';
          url += `${encodeURIComponent(data.name)}=${encodeURIComponent(data.value)}`;
          withVariables = true;
        }

      }
    }
    return withVariables ? url : '';

  }









  // FormPlyca

  private createFormConfig(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'SET_VARIABLES.json',
      this.model
    ));
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = false;
    formConfig.isModalWindow = false;
    return of(formConfig);
  }




}
